module.exports = __webpack_public_path__ + "img/15.8844dd41.jpg";